import { useCallback } from "react";
import { emitUserEvent as emit } from "@lookiero/user-tracking-front";
const useEmitUserEvent = () => {
    const emitUserEvent = useCallback((event) => emit(event), []);
    return emitUserEvent;
};
export { useEmitUserEvent };
